import { Api } from '@/munio/api/base'
import CompanyCharts from './CompanyCharts'
import { CompanyBasicResourceDto } from './data/CompanyBasicResource.dto'
import { CompanyAddressDto, CompanyResourceDto } from './data/CompanyResource.dto'
import { CollectionResponse, ResourceResponse } from './data/common'

class Companies extends Api {
  search(query: string, country: string, context = false, dropdown = false) {
    return this.$get(this.$route('api.web.companies'), window.cleanup({ query, country, context, dropdown }))
  }

  setContext(id: number) {
    return this.$post(this.$route('api.web.admin.company.context', { company: id }))
  }

  add(company: CompanyBasicResourceDto, redirect = false) {
    return this.$post(this.$route('api.web.admin.companies.create'), window.cleanup({ ...company, redirect }))
  }

  index(options?: URLSearchParams) {
    return this.$get<CollectionResponse<CompanyResourceDto>>(
      this.$route('api.web.admin.companies'),
      this.$query(options),
    )
  }

  id(id: number, context = false) {
    return new Company(id, context)
  }
}

class Company extends Api<{ company: number; context: boolean }> {
  constructor(
    protected id: number,
    protected context: boolean,
  ) {
    super({
      company: id,
      context,
    })
  }

  get() {
    return this.$get<ResourceResponse<CompanyResourceDto>>(this.$route('api.web.admin.company'))
  }

  update(data: object) {
    return this.$put<ResourceResponse<CompanyResourceDto>>(this.$route('api.web.admin.company.update'), data)
  }

  saveAddress(address: CompanyAddressDto) {
    return this.$put<ResourceResponse<CompanyResourceDto>>(this.$route('api.web.admin.company.address.save'), address)
  }

  deleteAddress(id: number) {
    return this.$delete<ResourceResponse<CompanyResourceDto>>(
      this.$route('api.web.admin.company.address.delete', {
        address: id,
      }),
    )
  }

  saveDomains(domains: string[]) {
    return this.$put<ResourceResponse<CompanyResourceDto>>(this.$route('api.web.admin.company.domains.save'), {
      domains,
    })
  }

  fetch() {
    return this.$get<ResourceResponse<CompanyResourceDto>>(this.$route('api.web.admin.company.fetch'))
  }

  get charts() {
    return new CompanyCharts(this.id)
  }
}

export default Companies
